import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

// Action types
export const TERMS_CREATE_REQUEST = 'TERMS_CREATE_REQUEST';
export const TERMS_CREATE_SUCCESS = 'TERMS_CREATE_SUCCESS';
export const TERMS_CREATE_FAILURE = 'TERMS_CREATE_FAILURE';

export const TERMS_LIST_REQUEST = 'TERMS_LIST_REQUEST';
export const TERMS_LIST_SUCCESS = 'TERMS_LIST_SUCCESS';
export const TERMS_LIST_FAILURE = 'TERMS_LIST_FAILURE';

export const TERMS_GET_REQUEST = 'TERMS_GET_REQUEST';
export const TERMS_GET_SUCCESS = 'TERMS_GET_SUCCESS';
export const TERMS_GET_FAILURE = 'TERMS_GET_FAILURE';

export const TERMS_UPDATE_REQUEST = 'TERMS_UPDATE_REQUEST';
export const TERMS_UPDATE_SUCCESS = 'TERMS_UPDATE_SUCCESS';
export const TERMS_UPDATE_FAILURE = 'TERMS_UPDATE_FAILURE';

export const TERMS_DELETE_REQUEST = 'TERMS_DELETE_REQUEST';
export const TERMS_DELETE_SUCCESS = 'TERMS_DELETE_SUCCESS';
export const TERMS_DELETE_FAILURE = 'TERMS_DELETE_FAILURE';

// Create
export const createTerm = ({ type, text }) => async (dispatch) => {
  dispatch({ type: TERMS_CREATE_REQUEST });
  try {
    const response = await api.post('termAndCondition/create', { type, text });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: TERMS_CREATE_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to create term';
    dispatch({ type: TERMS_CREATE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to create term';
    dispatch({ type: TERMS_CREATE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// List
export const listTerms = ({ page = 1, limit = 25, type } = {}) => async (dispatch) => {
  dispatch({ type: TERMS_LIST_REQUEST });
  try {
    // Send page/limit in query params; filters like type in body
    const response = await api.post('termAndCondition/list', { type }, { params: { page, limit } });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: TERMS_LIST_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch terms list';
    dispatch({ type: TERMS_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch terms list';
    dispatch({ type: TERMS_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// Get by id
export const getTermById = (id) => async (dispatch) => {
  dispatch({ type: TERMS_GET_REQUEST });
  try {
    const response = await api.post('termAndCondition/getById', { id });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: TERMS_GET_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch term';
    dispatch({ type: TERMS_GET_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch term';
    dispatch({ type: TERMS_GET_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// Update
export const updateTerm = ({ id, type, text }) => async (dispatch) => {
  dispatch({ type: TERMS_UPDATE_REQUEST });
  try {
    const response = await api.post('termAndCondition/update', { id, type, text });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: TERMS_UPDATE_SUCCESS, payload: response.data });
      showSuccess(response?.data?.message);
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to update term';
    dispatch({ type: TERMS_UPDATE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to update term';
    dispatch({ type: TERMS_UPDATE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// Delete
export const deleteTerm = (id) => async (dispatch) => {
  dispatch({ type: TERMS_DELETE_REQUEST });
  try {
    const response = await api.post('termAndCondition/delete', { id });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: TERMS_DELETE_SUCCESS, payload: { id, response: response.data } });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to delete term';
    dispatch({ type: TERMS_DELETE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to delete term';
    dispatch({ type: TERMS_DELETE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};


